import { Loader } from "components/Loader/Loader";
import React from "react";

type ButtonProps = {
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
    variant?: "solid" | "outline" | "ghost";
    size?: "sm" | "md" | "lg";
    type?: "button" | "submit" | "reset";
    form?:string;
    loading?:boolean
};

export const Button: React.FC<ButtonProps> = ({
    children,
    onClick,
    disabled = false,
    className = "",
    variant = "solid",
    size = "sm",
    type = "button",
    form,
    loading
}) => {
    const base ="rounded-xl font-medium transition-all flex gap-2 justify-center items-center  duration-200 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed";

    const sizes = {
        sm: "px-3 py-1.5 text-sm",
        md: "px-4 py-2 text-base",
        lg: "px-5 py-3 text-lg",
    };

    const variants = {
        solid:
        "bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800",
        outline:
        "border border-primary-600 text-primary-800 hover:bg-primary-50 active:bg-primary-100",
        ghost:
        "text-primary-800 hover:bg-primary-50 active:bg-primary-100",
    };

    return (
        <button
            form={form}
            type={type}
            onClick={onClick}
            disabled={disabled||loading}
            className={`${base} ${sizes[size]}  ${variants[variant]} ${className}`}
        >
            {loading&&<Loader  />}
            {children}
        </button>
    );
};

